/**
 * bgb-cart.js — mirrors Dawn's product-form.js exactly
 *
 * Key insight from product-form.js:
 *   const config = fetchConfig('javascript');
 *   delete config.headers['Content-Type'];       // must delete for FormData
 *   const formData = new FormData(this.form);
 *   formData.append('sections', cart.getSectionsToRender().map(s => s.id));
 *   formData.append('sections_url', window.location.pathname);
 *   config.body = formData;
 *
 * FormData.append converts the array to a comma-separated string automatically.
 * This is what makes Shopify return sections HTML in the response.
 */

window.BGBCart = window.BGBCart || (function () {

  function add(variantId, quantity, triggerEl, opts) {
    if (!variantId) return;
    quantity = quantity || 1;
    opts = opts || {};

    var cartEl = document.querySelector('cart-drawer') ||
                 document.querySelector('cart-notification');

    _setState(triggerEl, 'loading', opts.loadingLabel || 'Adding…');

    /* Build FormData exactly as Dawn's product-form.js does */
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    formData.append('sections_url', window.location.pathname);

    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      /* .map(s => s.id) returns ['cart-drawer','cart-icon-bubble']
         FormData converts that array to "cart-drawer,cart-icon-bubble" string */
      formData.append(
        'sections',
        cartEl.getSectionsToRender().map(function (s) { return s.id; })
      );
      if (typeof cartEl.setActiveElement === 'function') {
        cartEl.setActiveElement(triggerEl || document.activeElement);
      }
    }

    /* fetchConfig('javascript') sets Accept: application/javascript
       and Content-Type: application/json — but we must DELETE Content-Type
       so the browser sets it automatically with the FormData boundary */
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
        /* NO Content-Type — browser sets multipart/form-data with boundary */
      },
      body: formData
    })
    .then(function (res) { return res.json(); })
    .then(function (response) {

      if (response.status) {
        _setState(triggerEl, 'error', response.description || 'Error');
        return;
      }

      /* Remove is-empty before renderContents — same as product-form.js finally block */
      if (cartEl && cartEl.classList.contains('is-empty')) {
        cartEl.classList.remove('is-empty');
      }

      /* renderContents handles everything:
         1. Removes is-empty from .drawer__inner
         2. Updates #CartDrawer innerHTML with sections['cart-drawer']
         3. Updates #cart-icon-bubble innerHTML with sections['cart-icon-bubble']
         4. Calls this.open() */
      if (cartEl && typeof cartEl.renderContents === 'function') {
        cartEl.renderContents(response);
      }

      /* Publish Dawn's pub/sub event */
      if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'bgb-cart',
          productVariantId: String(variantId),
          cartData: response
        });
      }

      _setState(triggerEl, 'success',
        opts.addedLabel || '✓ Added',
        opts.addLabel   || 'Add to Cart'
      );
    })
    .catch(function (err) {
      console.error('BGBCart error:', err);
      _setState(triggerEl, 'error', opts.errorLabel || 'Error — try again');
    });
  }

  /* ── Button state management ── */
  function _setState(btn, state, label, resetLabel) {
    if (!btn) return;
    if (!btn.dataset.bgbOrigText) {
      var textEl = btn.querySelector('.bgb-btn-text, .bgb-pdp__btn-atc-text, span:not([aria-hidden])');
      btn.dataset.bgbOrigText  = textEl ? textEl.textContent.trim() : btn.textContent.trim();
      btn.dataset.bgbOrigBg    = btn.style.background || '';
      btn.dataset.bgbOrigColor = btn.style.color || '';
    }
    switch (state) {
      case 'loading':
        btn.disabled = true;
        btn.style.opacity = '0.75';
        btn.style.cursor = 'wait';
        _setText(btn, label);
        break;
      case 'success':
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = '';
        btn.style.background = btn.dataset.addedBg    || '#4a3728';
        btn.style.color      = btn.dataset.addedColor || '#fdf9f4';
        _setText(btn, label);
        var reset = resetLabel || btn.dataset.bgbOrigText;
        setTimeout(function () {
          btn.style.background = btn.dataset.bgbOrigBg    || '';
          btn.style.color      = btn.dataset.bgbOrigColor || '';
          _setText(btn, reset);
        }, 2400);
        break;
      case 'error':
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.cursor = '';
        btn.style.background = '#c0392b';
        btn.style.color = '#fff';
        _setText(btn, label);
        setTimeout(function () {
          btn.style.background = btn.dataset.bgbOrigBg    || '';
          btn.style.color      = btn.dataset.bgbOrigColor || '';
          _setText(btn, btn.dataset.bgbOrigText || 'Add to Cart');
        }, 3000);
        break;
    }
  }

  function _setText(btn, text) {
    if (!btn || !text) return;
    var span = btn.querySelector('.bgb-btn-text, .bgb-pdp__btn-atc-text, span:not([aria-hidden])');
    if (span) { span.textContent = text; return; }
    var svg = btn.querySelector('svg');
    if (svg) {
      Array.from(btn.childNodes).forEach(function (n) {
        if (n.nodeType === Node.TEXT_NODE) n.textContent = '';
      });
      btn.insertAdjacentText('beforeend', ' ' + text);
    } else {
      btn.textContent = text;
    }
  }

  return { add: add };

})();
